import { useCallback } from "react";

import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { PREMISE_TYPE } from "tagTypes";

export const usePremiseTypeQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/utility/premise-type",
    query,
    tags: [PREMISE_TYPE],
  });

export const useLazyPremiseTypeQuery = () => {
  const [getPremiseType, data] = useLazyGetQuery();
  const premiseType = async (query = {}) =>
    await getPremiseType(
      {
        endpoint: "/utility/premise-type",
        query,
        tags: [PREMISE_TYPE],
      },
      true
    ).unwrap();
  return [premiseType, data];
};

export const useLazyPremiseTypeByApplicantTypeQuery = () => {
  const [getPremiseTypeByApplicantType, data] = useLazyGetQuery();
  const premiseTypeByApplicantType = useCallback(
    async (applicantType, query = {}) => {
      await getPremiseTypeByApplicantType(
        {
          endpoint: `/applicant-type/${applicantType}/premise-type`,
          query,
          tags: [PREMISE_TYPE],
        },
        true
      ).unwrap();
    },
    [getPremiseTypeByApplicantType]
  );
  return [premiseTypeByApplicantType, data];
};

export const usePostPremiseTypeMutation = () => {
  const [premiseType, data] = usePostMutation();
  const addPremiseType = async (payload, query = {}) =>
    await premiseType({
      endpoint: "/premise-type",
      query,
      payload: payload || {},
      toastMessage: "Premise type added successfully",
      tags: [PREMISE_TYPE],
    }).unwrap();

  return [addPremiseType, data];
};

export const usePutPremiseTypeMutation = () => {
  const [premiseType, data] = usePutMutation();
  const updatePremiseType = async (payload, id, query = {}) =>
    await premiseType({
      endpoint: `/premise-type/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Premise type updated successfully",
      tags: [PREMISE_TYPE],
    }).unwrap();
  return [updatePremiseType, data];
};

export const useDeletePremiseTypeMutation = () => {
  const [premiseType, data] = useDeleteMutation();
  const deletePremiseType = async (id, query = {}) =>
    await premiseType({
      endpoint: `/premise-type/${id}`,
      query,
      toastMessage: "Premise type deleted successully",
      tags: [PREMISE_TYPE],
    }).unwrap();
  return [deletePremiseType, data];
};
